import { $isTextNode, DOMConversion, DOMConversionMap, LexicalNode, ParagraphNode } from 'lexical';

const patchStyleConversion =
  (originalDOMConverter?: (node: HTMLElement) => DOMConversion | null) => (node: HTMLElement) => {
    const original = originalDOMConverter?.(node);
    if (!original) {
      return null;
    }
    const originalOutput = original.conversion(node);

    if (!originalOutput) {
      return originalOutput;
    }

    return {
      ...originalOutput,
      forChild: (lexicalNode: LexicalNode, parent: LexicalNode | null | undefined) => {
        const originalForChild = originalOutput?.forChild ?? ((x) => x);
        const result = originalForChild(lexicalNode, parent);

        if ($isTextNode(result)) {
          const { cssText } = node.style;

          if (cssText.length) {
            return result.setStyle(cssText);
          }
        }
        return result;
      },
    };
  };

const overrideImportDOM = (originalImportDOM: () => DOMConversionMap | null) => {
  const importers = originalImportDOM();

  // override importers
  ParagraphNode.importDOM = () => ({
    ...importers,
    p: () => ({
      conversion: patchStyleConversion(importers?.p),
      priority: 0,
    }),
  });
};

export const extendParagraphNode = () => {
  const originalImportDOM = ParagraphNode.importDOM;

  overrideImportDOM(originalImportDOM);
};
